import React from 'react'
import Button from '../UI/Button'
import { useSuspendOrderMutation } from '../../store/orders/orders.api'

interface IProps {
  id: string | number
}

const SuspendOrderButton: React.FC<IProps> = ({ id }) => {
  const [suspendOrder, { isLoading }] = useSuspendOrderMutation()

  return (
    <Button 
      variant="filled"
      onClick={() => suspendOrder({ id })}
      disabled={isLoading}
    >
      Призупинити
    </Button>  
  )
}

export default SuspendOrderButton